var map = {
	"./layouts/card": 16,
	"./layouts/card/": 16,
	"./layouts/card/index": 16,
	"./layouts/card/index.tsx": 16,
	"./layouts/card/style.module": 99,
	"./layouts/card/style.module.scss": 99,
	"./layouts/components/breadcrumbs": 123,
	"./layouts/components/breadcrumbs/": 123,
	"./layouts/components/breadcrumbs/index": 123,
	"./layouts/components/breadcrumbs/index.tsx": 123,
	"./layouts/components/breadcrumbs/style.module": 183,
	"./layouts/components/breadcrumbs/style.module.scss": 183,
	"./layouts/components/container": 44,
	"./layouts/components/container/": 44,
	"./layouts/components/container/index": 44,
	"./layouts/components/container/index.tsx": 44,
	"./layouts/components/container/style.module": 125,
	"./layouts/components/container/style.module.scss": 125,
	"./layouts/components/footer": 124,
	"./layouts/components/footer/": 124,
	"./layouts/components/footer/index": 124,
	"./layouts/components/footer/index.tsx": 124,
	"./layouts/components/footer/style.module": 86,
	"./layouts/components/footer/style.module.scss": 86,
	"./layouts/components/loading_indicator": 55,
	"./layouts/components/loading_indicator/": 55,
	"./layouts/components/loading_indicator/index": 55,
	"./layouts/components/loading_indicator/index.tsx": 55,
	"./layouts/components/nav_bar": 97,
	"./layouts/components/nav_bar/": 97,
	"./layouts/components/nav_bar/index": 97,
	"./layouts/components/nav_bar/index.tsx": 97,
	"./layouts/components/nav_bar/standalone": 343,
	"./layouts/components/nav_bar/standalone.tsx": 343,
	"./layouts/components/nav_bar/style.module": 35,
	"./layouts/components/nav_bar/style.module.scss": 35,
	"./layouts/components/notice_banner": 85,
	"./layouts/components/notice_banner/": 85,
	"./layouts/components/notice_banner/assets/sale_tag_icon": 184,
	"./layouts/components/notice_banner/assets/sale_tag_icon.svg": 184,
	"./layouts/components/notice_banner/index": 85,
	"./layouts/components/notice_banner/index.tsx": 85,
	"./layouts/components/notice_banner/standalone": 344,
	"./layouts/components/notice_banner/standalone.tsx": 344,
	"./layouts/components/notice_banner/style.module": 185,
	"./layouts/components/notice_banner/style.module.scss": 185,
	"./layouts/page": 98,
	"./layouts/page/": 98,
	"./layouts/page/index": 98,
	"./layouts/page/index.tsx": 98,
	"./layouts/page/style.module": 87,
	"./layouts/page/style.module.scss": 87,
	"./layouts/types": 345,
	"./layouts/types.ts": 345,
	"./marketing/pages/home/toefl": 1610,
	"./marketing/pages/home/toefl/": 1610,
	"./marketing/pages/home/toefl/index": 1610,
	"./marketing/pages/home/toefl/index.tsx": 1610,
	"./marketing/pages/home/toefl/sections/ai": 1202,
	"./marketing/pages/home/toefl/sections/ai/": 1202,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_coaching_feature": 1877,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_coaching_feature.png": 1877,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_explanations_feature": 1878,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_explanations_feature.png": 1878,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_speaking_grading_feature": 1879,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_speaking_grading_feature.png": 1879,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_writing_grading_feature": 1880,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_writing_grading_feature.png": 1880,
	"./marketing/pages/home/toefl/sections/ai/assets/ets_badge": 1881,
	"./marketing/pages/home/toefl/sections/ai/assets/ets_badge.svg": 1881,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_bg": 1882,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_bg.svg": 1882,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_icon": 1883,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_icon.svg": 1883,
	"./marketing/pages/home/toefl/sections/ai/index": 1202,
	"./marketing/pages/home/toefl/sections/ai/index.tsx": 1202,
	"./marketing/pages/home/toefl/sections/ai/style.module": 1884,
	"./marketing/pages/home/toefl/sections/ai/style.module.scss": 1884,
	"./marketing/pages/home/toefl/sections/apps": 1203,
	"./marketing/pages/home/toefl/sections/apps/": 1203,
	"./marketing/pages/home/toefl/sections/apps/assets/app_store_icon": 1885,
	"./marketing/pages/home/toefl/sections/apps/assets/app_store_icon.svg": 1885,
	"./marketing/pages/home/toefl/sections/apps/assets/device_icon": 1886,
	"./marketing/pages/home/toefl/sections/apps/assets/device_icon.svg": 1886,
	"./marketing/pages/home/toefl/sections/apps/assets/flashcard_app": 1887,
	"./marketing/pages/home/toefl/sections/apps/assets/flashcard_app.png": 1887,
	"./marketing/pages/home/toefl/sections/apps/assets/play_store_icon": 1888,
	"./marketing/pages/home/toefl/sections/apps/assets/play_store_icon.svg": 1888,
	"./marketing/pages/home/toefl/sections/apps/assets/prep_app": 1889,
	"./marketing/pages/home/toefl/sections/apps/assets/prep_app.png": 1889,
	"./marketing/pages/home/toefl/sections/apps/index": 1203,
	"./marketing/pages/home/toefl/sections/apps/index.tsx": 1203,
	"./marketing/pages/home/toefl/sections/features": 1204,
	"./marketing/pages/home/toefl/sections/features/": 1204,
	"./marketing/pages/home/toefl/sections/features/assets/analytics_feature": 1890,
	"./marketing/pages/home/toefl/sections/features/assets/analytics_feature.png": 1890,
	"./marketing/pages/home/toefl/sections/features/assets/practice_tests_feature": 1891,
	"./marketing/pages/home/toefl/sections/features/assets/practice_tests_feature.png": 1891,
	"./marketing/pages/home/toefl/sections/features/assets/score_predictor_feature": 1892,
	"./marketing/pages/home/toefl/sections/features/assets/score_predictor_feature.png": 1892,
	"./marketing/pages/home/toefl/sections/features/assets/star_icon": 1893,
	"./marketing/pages/home/toefl/sections/features/assets/star_icon.svg": 1893,
	"./marketing/pages/home/toefl/sections/features/assets/student_help_feature": 1894,
	"./marketing/pages/home/toefl/sections/features/assets/student_help_feature.png": 1894,
	"./marketing/pages/home/toefl/sections/features/index": 1204,
	"./marketing/pages/home/toefl/sections/features/index.tsx": 1204,
	"./marketing/pages/home/toefl/sections/official_questions": 1208,
	"./marketing/pages/home/toefl/sections/official_questions/": 1208,
	"./marketing/pages/home/toefl/sections/official_questions/assets/official_questions_screen": 1903,
	"./marketing/pages/home/toefl/sections/official_questions/assets/official_questions_screen.png": 1903,
	"./marketing/pages/home/toefl/sections/official_questions/index": 1208,
	"./marketing/pages/home/toefl/sections/official_questions/index.tsx": 1208,
	"./marketing/pages/home/toefl/sections/official_questions/style.module": 743,
	"./marketing/pages/home/toefl/sections/official_questions/style.module.scss": 743,
	"./marketing/pages/home/toefl/sections/value_props": 1205,
	"./marketing/pages/home/toefl/sections/value_props/": 1205,
	"./marketing/pages/home/toefl/sections/value_props/assets/concentric_circles": 1895,
	"./marketing/pages/home/toefl/sections/value_props/assets/concentric_circles.svg": 1895,
	"./marketing/pages/home/toefl/sections/value_props/assets/magic_wand_icon": 1896,
	"./marketing/pages/home/toefl/sections/value_props/assets/magic_wand_icon.svg": 1896,
	"./marketing/pages/home/toefl/sections/value_props/index": 1205,
	"./marketing/pages/home/toefl/sections/value_props/index.tsx": 1205,
	"./marketing/pages/home/toefl/sections/value_props/style.module": 2281,
	"./marketing/pages/home/toefl/sections/value_props/style.module.scss": 2281,
	"./marketing/pages/home/toefl/sections/video_based_learning": 1206,
	"./marketing/pages/home/toefl/sections/video_based_learning/": 1206,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/focused_lesson_card": 1897,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/focused_lesson_card.png": 1897,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lesson_cards_bg": 1898,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lesson_cards_bg.png": 1898,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lucas_headshot": 1899,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lucas_headshot.png": 1899,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/play_icon": 1900,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/play_icon.svg": 1900,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/video_thumbnail": 1901,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/video_thumbnail.png": 1901,
	"./marketing/pages/home/toefl/sections/video_based_learning/index": 1206,
	"./marketing/pages/home/toefl/sections/video_based_learning/index.tsx": 1206,
	"./marketing/pages/home/toefl/sections/video_based_learning/style.module": 742,
	"./marketing/pages/home/toefl/sections/video_based_learning/style.module.scss": 742,
	"./marketing/pages/home/toefl/sections/wall_of_love": 1207,
	"./marketing/pages/home/toefl/sections/wall_of_love/": 1207,
	"./marketing/pages/home/toefl/sections/wall_of_love/assets/aybige_headshot": 1902,
	"./marketing/pages/home/toefl/sections/wall_of_love/assets/aybige_headshot.png": 1902,
	"./marketing/pages/home/toefl/sections/wall_of_love/index": 1207,
	"./marketing/pages/home/toefl/sections/wall_of_love/index.tsx": 1207,
	"./marketing/pages/home/toefl/style.module": 1904,
	"./marketing/pages/home/toefl/style.module.scss": 1904,
	"./marketing/pages/plans/toefl": 1611,
	"./marketing/pages/plans/toefl/": 1611,
	"./marketing/pages/plans/toefl/index": 1611,
	"./marketing/pages/plans/toefl/index.tsx": 1611,
	"./marketing/pages/plans/toefl/sections/testimonials": 1209,
	"./marketing/pages/plans/toefl/sections/testimonials/": 1209,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/mateus_headshot": 1905,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/mateus_headshot.png": 1905,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/nishant_headshot": 1906,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/nishant_headshot.png": 1906,
	"./marketing/pages/plans/toefl/sections/testimonials/index": 1209,
	"./marketing/pages/plans/toefl/sections/testimonials/index.tsx": 1209
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2621;